import type { CryptoWithdrawal } from '../@types/api';

export const WITHDRAWAL_STATE_LABELS: Record<CryptoWithdrawal['state'], string> = {
  awaiting_approval: 'Awaiting platform approval',
  submitting: 'Submitting to 0xProcessing',
  pending: 'Pending provider confirmation',
  unknown: 'Submission outcome unknown, check the 0x dashboard',
  review: 'Needs reconciliation, check the 0x dashboard',
  confirmed: 'Confirmed',
  aborted: 'Aborted by provider',
  rejected: 'Rejected before submission',
};

/** Awaiting approval only because 0x could not pay it when requested. */
export const isWaitingForLiquidity = (withdrawal?: CryptoWithdrawal) =>
  withdrawal?.state === 'awaiting_approval' && withdrawal.approvalReason === 'MERCHANT_LIQUIDITY_LOW';

/** Short operator notice for the 0x state, kept compact for narrow status cells. */
export const getZeroXStatusNotice = (withdrawal?: CryptoWithdrawal) =>
  isWaitingForLiquidity(withdrawal)
    ? {
        label: 'Low liquidity',
        hint: 'Merchant 0xProcessing balance was too low when requested. Top up, then approve.',
      }
    : null;
